window.theme = window.theme || {};
window.slate = window.slate || {};

theme.Filters = (function() {
  // Shopify.queryParams holds a string per key, or an array for a repeated key (see theme-core.js).
  function queryString(params) {
    var search = new URLSearchParams();
    Object.keys(params).forEach(function(key) {
      [].concat(params[key]).forEach(function(value) {
        search.append(key, value);
      });
    });
    return search.toString();
  }

  var selectors = {
    filterSelection: '#SortTags',
    sortSelection: '#SortBy',
    ajaxContent: '#CollectionAjaxContent',
    paginationLink: '.pagination a',
    // On every template using this class, unlike #CollectionAjaxContent (collection.liquid only).
    filterSection: '[data-section-type="collection-filters"]'
  };

  function Filters() {
    this.filterSelect = document.querySelector(selectors.filterSelection);
    this.sortSelect = document.querySelector(selectors.sortSelection);
    this.contentEl = document.querySelector(selectors.ajaxContent);
    this.sectionId = this.contentEl && this.contentEl.getAttribute('data-section-id');

    var filterSectionEl = document.querySelector(selectors.filterSection);
    this.collectionUrl = filterSectionEl && filterSectionEl.getAttribute('data-collection-url');

    // SortTags' own options, so a change replaces only its tag; fixed for the page (outside the AJAX area).
    this.sortTagValues = this.filterSelect
      ? Array.prototype.map.call(this.filterSelect.options, function(option) {
          return option.value;
        }).filter(function(value) {
          return value !== '';
        })
      : [];

    this.default = this._getDefaultSortValue();
    if (this.sortSelect) {
      this.sortSelect.value = this.default;
    }

    this._onFilterChangeHandler = this._onFilterChange.bind(this);
    this._onSortChangeHandler = this._onSortChange.bind(this);
    this._onPaginationClickHandler = this._onPaginationClick.bind(this);
    this._onPopStateHandler = this._onPopState.bind(this);
    this._onFacetChangeHandler = this._onFacetChange.bind(this);
    this._onFacetSubmitHandler = this._onFacetSubmit.bind(this);
    this._onDocumentClickHandler = this._onDocumentClick.bind(this);

    if (this.filterSelect) {
      this.filterSelect.addEventListener('change', this._onFilterChangeHandler);
    }
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', this._onSortChangeHandler);
    }
    if (this.contentEl) {
      // Pagination links and the facet filter form are replaced along with
      // the rest of the content on every AJAX render, so these are bound
      // once via delegation rather than re-bound to each new set of elements.
      this.contentEl.addEventListener('click', this._onPaginationClickHandler);
      this.contentEl.addEventListener('change', this._onFacetChangeHandler);
      this.contentEl.addEventListener('submit', this._onFacetSubmitHandler);
    }
    window.addEventListener('popstate', this._onPopStateHandler);
    document.addEventListener('click', this._onDocumentClickHandler);
  }

  Filters.prototype = Object.assign({}, Filters.prototype, {
    _getDefaultSortValue: function() {
      return (
        Shopify.queryParams.sort_by ||
        (this.sortSelect && this.sortSelect.dataset.defaultSort)
      );
    },

    // Single-select: drop any SortTags value from the active tags, then add the new choice.
    _onFilterChange: function() {
      if (!this.collectionUrl) return;

      var activeTags = this._getActiveTagsFromPath();
      var sortTagValues = this.sortTagValues;
      activeTags = activeTags.filter(function(tag) {
        return sortTagValues.indexOf(tag) === -1;
      });

      if (this.filterSelect.value !== '') {
        activeTags.push(this.filterSelect.value);
      }

      this._navigateWithTags(activeTags);
    },

    // Keeps the rest of the query string (sort_by, Price/Vendor filters) via Shopify.queryParams.
    _navigateWithTags: function(activeTags) {
      delete Shopify.queryParams.page;
      var query = queryString(Shopify.queryParams);
      this._navigate(this.collectionUrl + this._buildTagPathSuffix(activeTags) + (query ? '?' + query : ''));
    },

    _onSortChange: function() {
      Shopify.queryParams.sort_by = this.sortSelect.value;
      delete Shopify.queryParams.page;
      var query = queryString(Shopify.queryParams);
      this._navigate(location.pathname + (query ? '?' + query : ''));
    },

    _onPaginationClick: function(evt) {
      var link = evt.target.closest(selectors.paginationLink);
      if (!link) return;
      // Leave modified clicks (new tab/window, download) and target links to the browser.
      if (evt.defaultPrevented || evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
      if (link.target && link.target !== '_self') return;

      evt.preventDefault();
      this._navigate(link.href);
    },

    _onPopState: function() {
      this._syncQueryParamsFromLocation();
      this._syncControls();
      this._render(location.href, false);
    },

    // Shopify.queryParams is mutated across AJAX navigations; on popstate, re-read it from the URL.
    _syncQueryParamsFromLocation: function() {
      var params = {};
      new URLSearchParams(location.search).forEach(function(value, key) {
        var existing = params[key];
        if (existing === undefined) params[key] = value;
        else if (Array.isArray(existing)) existing.push(value);
        else params[key] = [existing, value];
      });
      Shopify.queryParams = params;
    },

    // The tag/sort <select> elements persist across AJAX renders (only the
    // grid + pagination are swapped), so on popstate their displayed value
    // needs to be brought back in sync with whatever URL was navigated to.
    _syncControls: function() {
      if (this.filterSelect) {
        // Option values are raw tags now, not full URLs (see the
        // constructor comment on sortTagValues) - whichever one (if any) is
        // currently in the tag path is this dropdown's selected value.
        var activeTags = this._getActiveTagsFromPath();
        var selectedTag = this.sortTagValues.filter(function(tag) {
          return activeTags.indexOf(tag) !== -1;
        })[0];
        this.filterSelect.value = selectedTag || '';
      }

      if (this.sortSelect) {
        this.sortSelect.value = this._getDefaultSortValue();
      }
    },

    _navigate: function(url, scrollToContent) {
      if (typeof scrollToContent === 'undefined') scrollToContent = true;
      history.pushState({}, '', url);
      this._syncQueryParamsFromLocation();
      this._render(url, scrollToContent);
    },

    _onFacetChange: function(evt) {
      if (!evt.target.closest('#FacetFiltersForm')) return;
      if (evt.target.type !== 'checkbox' && evt.target.type !== 'radio') return;
      if (evt.target.hasAttribute('data-tag-filter')) {
        this._submitFacetForm(evt.target);
      } else {
        this._submitFacetForm();
      }
    },

    _onFacetSubmit: function(evt) {
      if (!evt.target.closest('#FacetFiltersForm')) return;
      evt.preventDefault();
      this._submitFacetForm();
    },

    // Tags go in the URL path (see collection-filters.liquid), other fields in the query string;
    // both are rebuilt every time so neither change drops the other.
    _submitFacetForm: function(toggledTagCheckbox) {
      var form = this.contentEl.querySelector('#FacetFiltersForm');
      if (!form || !this.collectionUrl) return;

      var activeTags = this._getActiveTagsFromPath();

      if (toggledTagCheckbox) {
        var tagValue = toggledTagCheckbox.value;
        var index = activeTags.indexOf(tagValue);
        if (toggledTagCheckbox.checked && index === -1) {
          activeTags.push(tagValue);
        } else if (!toggledTagCheckbox.checked && index !== -1) {
          activeTags.splice(index, 1);
        }
      }

      var params = new URLSearchParams();
      new FormData(form).forEach(function(value, key) {
        if (value !== '') params.append(key, value);
      });

      var query = params.toString();
      this._navigate(this.collectionUrl + this._buildTagPathSuffix(activeTags) + (query ? '?' + query : ''), false);
    },

    // Shared by _submitFacetForm and _onFilterChange (SortTags), which build
    // the rest of the URL differently (a form field query string vs
    // Shopify.queryParams) but both need the same tag-path segment.
    _buildTagPathSuffix: function(activeTags) {
      return activeTags.length
        ? '/' + activeTags.map(encodeURIComponent).join('+')
        : '';
    },

    // Like Liquid's current_tags, but from location.pathname so it follows pushState navigations.
    _getActiveTagsFromPath: function() {
      var path = location.pathname;
      if (!this.collectionUrl || path.indexOf(this.collectionUrl) !== 0) return [];

      var suffix = path.slice(this.collectionUrl.length).replace(/^\/+/, '');
      if (!suffix) return [];

      return suffix.split('+').map(decodeURIComponent);
    },

    // <details> elements don't close on an outside click by default, which
    // leaves stale open filter dropdowns behind once another one is opened
    // or the page is interacted with elsewhere.
    _onDocumentClick: function(evt) {
      if (!this.contentEl) return;
      var openGroups = this.contentEl.querySelectorAll('.filter-group[open]');
      Array.prototype.forEach.call(openGroups, function(group) {
        if (!group.contains(evt.target)) group.removeAttribute('open');
      });
    },

    _render: function(url, scrollToContent) {
      if (!this.contentEl || !this.sectionId) {
        location.href = url;
        return;
      }

      var self = this;
      this.contentEl.classList.add('loading');

      // Abort the previous request so a slow older response can't overwrite this one.
      if (this.renderController) this.renderController.abort();
      var controller = new AbortController();
      this.renderController = controller;

      var separator = url.indexOf('?') === -1 ? '?' : '&';
      fetch(url + separator + 'section_id=' + this.sectionId, { signal: controller.signal })
        .then(function(res) {
          if (!res.ok) throw new Error('Collection filter request failed with status ' + res.status);
          return res.text();
        })
        .then(function(html) {
          if (controller.signal.aborted) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newContent = doc.querySelector(selectors.ajaxContent);
          if (!newContent) throw new Error('Collection filter response missing content');

          self.contentEl.innerHTML = newContent.innerHTML;
          self.contentEl.classList.remove('loading');

          // New cards arrive with default visibility; re-apply the country rules.
          if (window.geoCountryCode && typeof window.applyGeoVisibility === 'function') {
            window.applyGeoVisibility(window.geoCountryCode);
          }

          if (scrollToContent) {
            self.contentEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        })
        .catch(function() {
          if (controller.signal.aborted) return;
          // Fall back to a full navigation if the AJAX update fails, so the
          // grid is never left showing stale/mismatched products.
          location.href = url;
        });
    },

    onUnload: function() {
      if (this.filterSelect) {
        this.filterSelect.removeEventListener('change', this._onFilterChangeHandler);
      }
      if (this.sortSelect) {
        this.sortSelect.removeEventListener('change', this._onSortChangeHandler);
      }
      if (this.contentEl) {
        this.contentEl.removeEventListener('click', this._onPaginationClickHandler);
        this.contentEl.removeEventListener('change', this._onFacetChangeHandler);
        this.contentEl.removeEventListener('submit', this._onFacetSubmitHandler);
      }
      window.removeEventListener('popstate', this._onPopStateHandler);
      document.removeEventListener('click', this._onDocumentClickHandler);
    }
  });

  return Filters;
})();
